module.exports = __webpack_public_path__ + "b06f43aba034a6abe7e2ac6a8f58b5b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/heldenkult_inactive.svg
// module id = 29
// module chunks = 0